import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => ({
  newsCard: {
    display: 'flex',
    flexDirection: 'column', // Cambiado a 'column'
    background: 'white',
    boxShadow: '0px 2px 14px rgba(0, 0, 0, 0.1)',
    borderRadius: '8px',
    width: '100%',
    height: '130px',
    marginBottom: '12px',
    cursor: 'pointer',
    '&:hover': {
      transition: '0.2s',
      boxShadow: '2px 2px 8px 5px rgba(0,0,0,0.08)',
    },
    [theme.breakpoints.up('sm')]: {
      display: 'flex',
      flexDirection: 'column',
      marginRight: '22px',
    },
    justifyContent: 'space-around',
  },
  
  content: {
    display: 'flex',
    flexDirection: 'row',
    height: '100%',
    alignItems: 'center',
  },
  
  imageContainer: {
    width: '34%',
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
  },
  thumbnailWrapper: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100%',
    boxSizing: 'border-box',
  },
  thumbnail: {
    width: '130px',
    height: '130px',
    objectFit: 'cover',
    borderRadius: '6px 0px 0px 6px',
  },
  textContainer: {
    flex: '1',
    padding: '5px 20px 0px 20px',
    display: 'flex',
    height:'120px',
    flexDirection: 'column',
    justifyContent: 'space-between',
  },
  minuts: {
    flex: '1',
    padding: '0px 0px 10px 50px',
    display: 'flex',
    justifyContent: 'flex-end',
  },
  description: {
    margin: 0,
    color: '#C4C4C4',
    fontFamily: 'Inter',
    fontSize: '13px',
    fontStyle: 'normal',
    fontWeight: '500',
    lineHeight: '20.8px',
    marginBottom: '8px',
  },
  notice: {
    margin: 0,
    color: 'rgba(0, 0, 0, 0.87)',
    fontFamily: 'Inter',
    fontSize: '20px',
    fontStyle: 'normal',
    fontWeight: '500',
    lineHeight: '20.8px',
    marginBottom: '8px',
  },
  title: {
    display: 'flex',
    margin: '0',
    color: 'rgba(0, 0, 0, 0.87)',
    fontFamily: 'Yantramanav',
    fontSize: '16px',
    fontStyle: 'normal',
    fontWeight: 'normal',
    lineHeight: '22px',
    marginBottom: '8px',
  },
  readingTime: {
    margin: 0,
    color: '#4AA259',
    fontFamily: 'Yantramanav',
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: '400',
    lineHeight: '12.52px',
    alignSelf: 'flex-end',
  },
}));
